import React from 'react';

/* Shows a picture the way the app draws a banner: a 16:6 box, image stretched to fill it. */
export const BannerPreview = ({ src, label }) => {
  if (!src) return null;
  return (
    <div className="mb-3">
      {label && <div className="text-muted small mb-1">{label}</div>}
      <div style={{ position: 'relative', width: '100%', maxWidth: 480, paddingTop: 'min(37.5%, 180px)', borderRadius: 12, overflow: 'hidden', background: '#f3f3f3' }}>
        <img src={src} alt="Banner preview"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'fill' }} />
      </div>
    </div>
  );
};

export default BannerPreview;
